import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from 'react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Logo from 'assets/images/logo.svg';
import { codeForgotPassword } from 'api/auth/forgot-password/codeForgotPassword';
import { schemaStep2 } from 'api/auth/types';

export default function VerificationsCode() {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const uidb64FromUrl = searchParams.get('uidb64');
  const tokenFromUrl = searchParams.get('token');
  const requestSentRef = useRef(false);
  const formStep2 = useForm({
    resolver: zodResolver(schemaStep2),
    defaultValues: {
      uidb64: uidb64FromUrl || '',
      token: tokenFromUrl || '',
    },
  });
  const { mutate: handleCodeForgotPassword, isLoading } = useMutation({
    mutationFn: codeForgotPassword,
    onSuccess: _response => {
      navigate(`/complete-password?uidb64=${uidb64FromUrl}&token=${tokenFromUrl}`);
    },
    onError: (error: any) => {
      setErrorMessage(error.response?.data?.error || 'Verification failed');
    },
  });

  useEffect(() => {
    if (uidb64FromUrl && tokenFromUrl && !requestSentRef.current) {
      requestSentRef.current = true;

      formStep2.setValue('uidb64', uidb64FromUrl);
      formStep2.setValue('token', tokenFromUrl);

      handleCodeForgotPassword({
        uidb64: uidb64FromUrl,
        token: tokenFromUrl,
      });
    }
  }, [uidb64FromUrl, tokenFromUrl, formStep2, handleCodeForgotPassword]);
  return (
    <div className="auth-page-wrapper pt-5">
      <div className="auth-page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <a href="https://trojan.systems/" className="d-inline-block auth-logo">
                    <img src={Logo} alt="" height="50" />
                  </a>
                </div>
                <p className="mt-3 fs-15 fw-medium text-primary">Smart pest management</p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-4">
                <div className="card-body p-4 text-center">
                  <h5 className="text-primary">Verifying your link...</h5>

                  {isLoading && (
                    <div className="spinner-border text-primary mt-3" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}

                  <div className="p-2 mt-4" style={{ display: isLoading ? 'none' : 'block' }}>
                    {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <p className="mb-0 text-muted">
                  © {new Date().getFullYear()} Trojan LLC. Crafted with <i className="mdi mdi-heart text-danger" /> by
                  Trojan Systems
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
